/* eslint-disable @typescript-eslint/no-explicit-any */
import * as React from 'react';
import { Typography, Grid, Avatar, Switch } from '@mui/material';
import { Box } from '@mui/system';
import ActiveBox from '../ActiveBox/ActiveBox';
import { alpha,styled } from '@mui/material/styles';
import { employeeDirectoryService } from '../../../api/services/employeeDirectoryService';
import { colors } from '../../../helpers';
import { useAppSelector } from '../../../infra/hooks';
import _ from "lodash";
import './EmpDirectoryBox.css'

const styles: any = {
  box: {
    border: '1px solid #0000001F',
    height: '12.8em',
    width: 'auto',
    minWidth: '15.5em',
    borderRadius: '0.9375em',
    padding: '0.9em',
    display: 'flex',
    flexDirection: 'column',
  },
  title: {
    fontFamily: 'Lato',
    fontWeight: 'bold',
    color: '#081735',
  },
  subtitle: {
    fontFamily: 'Lato',
    color: '#8181A5',
  },
  staffButton: {
    fontFamily: 'Lato',
    fontSize: '0.75em',
    borderRadius: '1em',
    backgroundColor: '#E6E8EF',
    height: '1.625em',
    width: '3.5em',
    alignItems: 'center',
    justifyContent: 'center',
    display: 'flex',
  },
  box2: {
    height: '4em',
    backgroundColor: '#F5F5FA66',
    borderRadius: '0.25em',
    padding: '0.5em',
  },
  docs: {
    fontFamily: 'Lato',
    color: '#8181A5',
    fontWeight: 'bold',
  },

  editbox: {
    border: '1px solid #E6E8EF',
    color: '#21D8A5',
    width: '1.8125em',
    height: '1.8125em',
    alignItems: 'center',
    justifyContent: 'center',
    display: 'flex',
    borderRadius: '0.375em',
    cursor: 'pointer',
  },
};

const GreenSwitch = styled(Switch)(({ theme }) => ({
  '& .MuiSwitch-switchBase.Mui-checked': {
    color: colors.red,
    '&:hover': {
      backgroundColor: alpha(colors.green, theme.palette.action.hoverOpacity),
    },
  },
  '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
    backgroundColor: colors.red,
  },
}));


const EmpDirectoryBox = (props: any) => {

  const [activeStatus, setActiveStatus] = React.useState<boolean>(props?.data?.is_active);
  const [userRoleInfo, setUserRoleInfo] = React.useState<any>([]) 
  const [editAccess, setEditAccess] = React.useState<boolean>() 
  const access = useAppSelector((state)=>state.roleInfo.editAccess)

  React.useEffect(() => {
    setActiveStatus(props?.active);
  }, [props?.active]);

  const handleChangeStatus = (val:any, id:number) =>{
      const checked = val.target.checked;
      employeeDirectoryService
      .editAccess(id,checked)
      .then((response:any)=>{
        if(response.data == "Is_Active"){
          setActiveStatus(true)
        }else{
          setActiveStatus(false)
        }
      })
  }

  React.useEffect(()=>{
    if(access){
      checkAccess()
    }
  },[access])

  const checkAccess = () =>{
    if (access == true){
      setEditAccess(true)
    }else{
      setEditAccess(false)
    }
  }
  return (
    <Box style={styles.box}>
      <Grid container sx={{marginBottom:"10px",display:'flex',justifyContent:'space-between'}}>
        <Grid item>
          <ActiveBox value={activeStatus}/>
        </Grid>
        {/* <Grid item></Grid>
        <Grid item >
        {editAccess == true && 
          <label className="switchSmall2 m5">
          <input 
          type="checkbox" 
          onChange={(newValue) => {
                  handleChangeStatus(newValue, props?.data?.user_id);
                }}
          checked={activeStatus} />
          <small></small>
        </label>        
        }
        </Grid> */}
      </Grid>
      <Grid container spacing={2}>
        <Grid item>
          <Avatar
            src={props.profile}
            style={{ flex: 1, height: '3em', width: '3em' }}
          />
        </Grid>
        <Grid item style={{ flex: 1 }}>
          <Typography style={styles.title} sx={{ fontSize: '0.875em' }}>
            {props.title}
          </Typography>
          <Typography
            style={styles.subtitle}
            sx={{ fontSize: '0.75em', marginTop: '0.2em' }}
          >
            {props.designation}
          </Typography>
          <Typography
            style={styles.subtitle}
            sx={{ fontSize: '0.75em', marginTop: '0.1em' }}
          >
            {props.department}
          </Typography>
        </Grid>
      </Grid>
      <Grid container style={{ marginTop: '1em' }}>
        <Grid item xs={12}>
          <Box style={styles.box2}>
            <Grid
              container
              spacing={1}
              style={{
                alignItems: 'center',
              }}
            >
              <Grid item>
                <i
                  className="las la-envelope-open"
                  style={{ color: '#8181A5' }}
                ></i>
              </Grid>
              <Grid item>
                <Typography style={{ fontFamily: 'Lato', fontSize: '0.8em' }}>
                  {props.email}
                </Typography>
              </Grid>
            </Grid>
            <Grid
              container
              spacing={1}
              style={{
                alignItems: 'center',
              }}
            >
              <Grid item>
                <i
                  className="las la-phone-volume"
                  style={{ color: '#8181A5' }}
                ></i>
              </Grid>
              <Grid item>
                <Typography style={{ fontFamily: 'Lato', fontSize: '0.75em' }}>
                  {props.mobile}
                </Typography>
              </Grid>
            </Grid>
            <Grid
              container
              spacing={1}
              style={{
                alignItems: 'center',
              }}
            >
              <Grid item>
                <i className="las la-tty" style={{ color: '#8181A5' }}></i>
              </Grid>
              <Grid item>
                <Typography style={{ fontFamily: 'Lato', fontSize: '0.75em' }}>
                  {props.landline}
                </Typography>
              </Grid>
            </Grid>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default EmpDirectoryBox;